const AGENT_NEVER_READS = 'agentNeverReads';
export function agentNeverReads(schema) {
    return schema.meta({ [AGENT_NEVER_READS]: true });
}
export function isAgentNeverReads(node) {
    return node[AGENT_NEVER_READS] === true;
}
//# sourceMappingURL=agentNeverReads.js.map